// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___UnQ9g","button":"styles__button___1C0tw","modal":"styles__modal___2Dg23","overlay":"styles__overlay___1pDq2","modalButton":"styles__modalButton___1_5AF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/collaborator-panel/styles.css
// module id = 1089
// module chunks = 0